import React, { Component } from 'react'

import './css.css';


class Empty extends Component {
   
    render(){
        
        return ( 
           <></>
        );
        
    }


}




export default Empty